import { useIntl } from '@/intl'
import { tk, Typography } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const DayWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  height: 100%;
`

export const Weekday = styled(Typography)`
  color: ${tk('color_semantic_text_subdued')};
`

export const DayAndMonth = styled(Typography)`
  color: ${tk('color_semantic_text_subdued_hover')};
`

export function Day({ date }: { date: string }) {
  const intl = useIntl()
  return (
    <DayWrapper>
      <Weekday $variant="body-sm">
        {intl.formatDate(date, {
          weekday: 'long',
        })}
      </Weekday>
      <DayAndMonth $variant="body-sm">
        {intl.formatDate(date, {
          day: 'numeric',
          month: 'short',
        })}
      </DayAndMonth>
    </DayWrapper>
  )
}
